<div class="modal-header d-flex align-items-center justify-content-between w-100">
    <div class="title-section d-flex align-items-center gap-2">
        <div class="title"> 
            <span> {{ 'cookie.title' | translate}} </span>
        </div>

        <button 
            class="btn toggle-cookie-message-btn" 
            (click)="toggleCookieMessageHandler()"> 
            <span> {{ (isCookieMessageExpanded ? 'cookie.hideDetails' : 'cookie.showDetails') | translate }}  </span>
        </button>
    </div>

    <button type="button" class="btn btn-primary text-white" (click)="acceptAll()">
        {{ 'cookie.accept' | translate }}
    </button>
</div>
    
<div *ngIf="isCookieMessageExpanded" class="modal-body flex-grow-1 w-100">
    <span [innerHtml]="message"></span>
</div>